import { render, staticRenderFns } from "./usersTableItem.vue?vue&type=template&id=3b88fabf&scoped=true&"
import script from "./usersTableItem.vue?vue&type=script&lang=js&"
export * from "./usersTableItem.vue?vue&type=script&lang=js&"
import style0 from "./usersTableItem.vue?vue&type=style&index=0&id=3b88fabf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88fabf",
  null
  
)

export default component.exports